(function () {
  'use strict';

  angular
    .module('dashboard.lead.working')
    .factory('DashboardLeadWorking', DashboardLeadWorking);

  DashboardLeadWorking.$inject = ['$resource'];

  function DashboardLeadWorking($resource) {
    return $resource(
      '/api/',
      {},
      {
        getLeadNurturing: {
          method: 'GET',
          url: '/api/dashboard/statistic/leadNurturing',
          isArray: true,
        },
      },
    );
  }
})();
